'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  list-style: none;\n  padding: 5px;\n  margin: 0;\n  font-size: 0.75em;\n'], ['\n  list-style: none;\n  padding: 5px;\n  margin: 0;\n  font-size: 0.75em;\n']),
    _templateObject2 = _taggedTemplateLiteral([''], ['']),
    _templateObject3 = _taggedTemplateLiteral(['\n  margin-left: 5px;\n'], ['\n  margin-left: 5px;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var UL = _styledComponents2.default.ul(_templateObject);

var COMMAND = _styledComponents2.default.li(_templateObject2);

var PARAMETER = _styledComponents2.default.li(_templateObject3);

var Buildup = function (_Component) {
  _inherits(Buildup, _Component);

  function Buildup() {
    _classCallCheck(this, Buildup);

    return _possibleConstructorReturn(this, (Buildup.__proto__ || Object.getPrototypeOf(Buildup)).apply(this, arguments));
  }

  _createClass(Buildup, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        UL,
        null,
        this.props.enteredCommands.map(function (_ref) {
          var phase = _ref.phase,
              copy = _ref.copy;
          return phase === 'command' ? _react2.default.createElement(
            COMMAND,
            { key: copy },
            copy
          ) : _react2.default.createElement(
            PARAMETER,
            { key: copy },
            copy
          );
        })
      );
    }
  }]);

  return Buildup;
}(_react.Component);

exports.default = Buildup;


//////////////////
// WEBPACK FOOTER
// ./~/react-commander/lib/components/Buildup.js
// module id = 833
// module chunks = 107818501498521